export default {
  formatTicketForPrint(ticket) {
    return {
      ...ticket,
      version2: true,
      bets: _.map(ticket.bets, (bet) => {
        const patterns = ['[X]', '[Y]', '[Z]', '[Q]'];
        const parts = bet.specialValue.toString().split('|');
        let replaced = false;
        let formattedName = bet.bet.betDisplayName || bet.bet.betShortName;

        _.each(parts, (part, i) => {
          const pattern = patterns[i];

          if (!_.includes(formattedName, pattern)) return;

          formattedName = _.replace(formattedName, pattern, part);
          replaced = true;
        });

        if (!replaced && bet.specialValue && bet.specialValue !== '*') {
          const sv = !bet.bet.betGroupingEnabled ? `(${bet.specialValue})` : '';
          formattedName = `${formattedName} ${sv}`;
        }

        return {
          ...bet,
          bet: {
            ...bet.bet,
            formattedName,
          },
        };
      }),
    };
  },
  formatTicketForSeven(ticket, translation, taxes = {}) {
    if (_.isEmpty(ticket)) return {};

    const formatted = this.formatTicketForPrint(ticket);
    const id = _.find(formatted.ticketHashes, hash => _.lowerCase(hash.type) === 'normal');

    formatted.product = formatted.product || 'PreMatchBetting';
    formatted.translation = translation;
    formatted.id = id ? id.hash : `${formatted.id}`;
    formatted.taxes = taxes;

    if (!formatted.status) formatted.status = {};
    if (formatted.type === '2') formatted.ticketCombinationGroups = ticket.ticketCombinationGroups;

    return formatted;
  },
};
